import { isDev } from "../is-dev";

export { }

declare global {
    interface Console {
        logDev(message?: any, ...optionalParams: any[]): void;
    }
}
if (!console.logDev) {
    console.logDev = function (message?: any, ...optionalParams: any[]): void {
        if (isDev)
            console.log(message, optionalParams);
    }
}